import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronDown, FaHome, FaDollarSign, FaBars, FaSignOutAlt } from "react-icons/fa";
import SideDrawer from "./SideDrawer"; // Import SideDrawer component

const NavBar = () => {
  const navigate = useNavigate();
  const [dropdown, setDropdown] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = (menu) => {
    setDropdown(dropdown === menu ? null : menu);
  };

  const closeDropdown = () => {
    setDropdown(null);
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="bg-white shadow-md py-4 px-6 flex justify-between items-center">
      {/* Logo */}
      <h1
        className="text-2xl font-bold text-primaryOrange flex items-center space-x-2 cursor-pointer"
        onClick={() => navigate("/")}
      >
        <FaHome className="text-primaryOrange" />
        <span>housing.in</span>
      </h1>

      {/* Navigation Links */}
      <div className="flex items-center space-x-6" ref={dropdownRef}>
        {/* Post Property */}
        <button
          className="text-gray-800 hover:text-primaryOrange transition duration-300 ease-in-out text-md font-semibold flex items-center"
          onClick={() => navigate("/post-property")}
        >
          {/* <FaDollarSign className="mr-2" /> */}
          Post Property
        </button>

        {/* Home Loan Dropdown */}
        <div className="relative">
          <button
            className="text-gray-800 hover:text-primaryOrange transition duration-300 ease-in-out text-md font-semibold flex items-center"
            onClick={() => toggleDropdown("homeLoan")}
          >
            Home Loan <FaChevronDown className="ml-2 text-sm" />
          </button>
          {dropdown === "homeLoan" && (
            <div className="absolute bg-white shadow-lg rounded-md mt-2 w-48 z-10">
              <ul className="text-gray-800">
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/apply-for-loans")}
                >
                  Apply for Loan
                </li>
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/eligibility-calculator")}
                >
                  Eligibility Calculator
                </li>
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/emi-calculator")}
                >
                  EMI Calculator
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* Buy Dropdown */}
        <div className="relative">
          <button
            className="text-gray-800 hover:text-primaryOrange transition duration-300 ease-in-out text-md font-semibold flex items-center"
            onClick={() => toggleDropdown("buy")}
          >
            Buy <FaChevronDown className="ml-2 text-sm" />
          </button>
          {dropdown === "buy" && (
            <div className="absolute bg-white shadow-lg rounded-md mt-2 w-48 z-10">
              <ul className="text-gray-800">
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/buy-a-property")}
                >
                  Buy a Property
                </li>
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/no-brokerage-policy")}
                >
                  No Brokerage Policy
                </li>
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/home-buying-guide")}
                >
                  Home Buying Guide
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* Sell Dropdown */}
        <div className="relative">
          <button
            className="text-gray-800 hover:text-primaryOrange transition duration-300 ease-in-out text-md font-semibold flex items-center"
            onClick={() => toggleDropdown("sell")}
          >
            Sell <FaChevronDown className="ml-2 text-sm" />
          </button>
          {dropdown === "sell" && (
            <div className="absolute bg-white shadow-lg rounded-md mt-2 w-48 z-10">
              <ul className="text-gray-800">
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/post-property")}
                >
                  Sell Your Property
                </li>
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/home-worth-calculator")}
                >
                  Home Worth Calculator
                </li>
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/home-selling-guide")}
                >
                  Home Selling Guide
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* Rent Dropdown */}
        <div className="relative">
          <button
            className="text-gray-800 hover:text-primaryOrange transition duration-300 ease-in-out text-md font-semibold flex items-center"
            onClick={() => toggleDropdown("rent")}
          >
            Rent <FaChevronDown className="ml-2 text-sm" />
          </button>
          {dropdown === "rent" && (
            <div className="absolute bg-white shadow-lg rounded-md mt-2 w-48 z-10">
              <ul className="text-gray-800">
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/rent-a-property")}
                >
                  Rent a Property
                </li>
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/no-brokerage-policy")}
                >
                  No Brokerage Policy
                </li>
                <li
                  className="hover:bg-blue-100 px-4 py-2 cursor-pointer"
                  onClick={() => navigate("/renters-guide")}
                >
                  Renters Guide
                </li>
              </ul>
            </div>
          )}
        </div>

        <button
        className="text-primaryOrange text-2xl"
        onClick={toggleDrawer}
      >
        <FaBars />
      </button>

        {/* Log In */}
        <button
          className="bg-primaryOrange text-white py-2 px-4 rounded-lg hover:bg-orange-600 transition duration-300 ease-in-out flex items-center"
          onClick={() => navigate("/")}
        >
          <FaSignOutAlt className="mr-2" />
          Log In
        </button>
      </div>
      {/* Side Drawer Component */}
      {isDrawerOpen && (
        <SideDrawer
          isOpen={isDrawerOpen}
          toggleDrawer={toggleDrawer}
          navigate={navigate}
          toggleDropdown={toggleDropdown}
          dropdown={dropdown}
        />
      )}
    </div>
  );
};

export default NavBar;
